import { Navigate } from 'react-router';

import { useTokenClaims } from '@app-velocity/request-gateway';

import { Authorized } from './Authorized/Authorized';

export const Home = () => {
  const readTokenClaim = useTokenClaims();
  const userId = readTokenClaim('sub')?.toString();

  if (userId) return <Authorized />;

  return <Navigate to="/guest" />;
};
